import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const loginNavigate =(userRole)=>{
   switch (userRole) {
    case 'vendor':
      return <Navigate to="/vendor/dashboard" />;
    case 'user':
      return <Navigate to="/LocalActivities" />;
    case 'public':
      return <Navigate to="/" />;
    default:
      return <Navigate to="/" />;
  }
}

const PrivateRoute = ({ 
  allowedRoles = [], 
  isPublic = false,
  isAuthRoute = false // New prop for routes only accessible to unauthenticated users
}) => {
  const { isAuthenticated, loading, userRole } = useAuth();

  if (loading) return null; // or a spinner/loading UI

  // Handle routes that should only be accessible to unauthenticated users
  if (isAuthRoute) {
    return isAuthenticated ? loginNavigate(userRole) : <Outlet />;
  }

  // If route is public, allow all access
  if (isPublic) return <Outlet />;

  // If not authenticated, redirect to login
  if (!isAuthenticated) return <Navigate to="/login" />;

  // If no specific roles required or user's role is allowed
  if (allowedRoles.length === 0 || allowedRoles.includes(userRole)) {
    return <Outlet />;
  }

  // If user doesn't have required role, redirect to appropriate page
  switch (userRole) {
    case 'vendor':
      return <Navigate to="/vendor/dashboard" />;
    case 'user':
      return <Navigate to="/LocalActivities" />;
    case 'public':
      return <Navigate to="/" />;
    default:
      return <Navigate to="/" />;
  }
};

export default PrivateRoute;